.failureContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: 0.875rem;
    padding: 4rem;
}

.failureTitle {
    color: #DA252D;
    font-size: var(--fs-small-heading);
}

.failureMessage {
    color: var(--static-text-standard);
    font-size: var(--fs-small);
    text-align: center;
}